export var LegalDocumentStatus;
(function (LegalDocumentStatus) {
    LegalDocumentStatus["DRAFT"] = "DRAFT";
    LegalDocumentStatus["ACTIVE"] = "ACTIVE";
    LegalDocumentStatus["ARCHIVED"] = "ARCHIVED";
})(LegalDocumentStatus || (LegalDocumentStatus = {}));
//# sourceMappingURL=legal-document.types.js.map